import {
  Add as AddIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { TableSkeleton } from "../../../../components/TableSkeleton";
import CustomTextField from "../../../../components/Textfield";
import useCourses from "../../../../hooks/useCourses";

const CourseManagement = () => {

  //hooks
  const { addCourse, isAddingCourse, courses, isCoursesLoading, updateCourse, isUpdatingCourse, deleteCourse, isDeletingCourse } = useCourses();
  console.log({ isAddingCourse });
  const { register, handleSubmit, watch, formState: { errors }, setValue, reset, getValues } = useForm();

  // Dialog state

  const [open, setOpen] = useState(false);
  const [deleteCourseId, setDeleteCourseId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [newSubject, setNewSubject] = useState({ name: "", marks: 100, isPractical: false });

  console.log({ newSubject });

  const currentSubjects = getValues("subjects") || [];

  const handleOpenDialog = (course = null) => {

    if (course) {
      reset(course);
      setIsEditing(true);
    } else {
      reset({
        title: "",
        code: "",
        duration: "",
        subjects: [],
      });
      setIsEditing(false);
    }
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };


  const handleSubjectChange = (e) => {
    const { name, value, type, checked } = e.target;

    setNewSubject((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : name === "marks"
            ? value === "" ? "" : parseInt(value, 10)
            : value,
    }));
  };
  
  const handleAddSubject = () => {
    if (newSubject.name.trim()) {

      console.log({ newSubject });

      const updatedSubjects = [...currentSubjects, newSubject];

      setValue("subjects", updatedSubjects); // Update form field
      setNewSubject({ name: "", marks: 100 }); // Reset input
    }
  };


  const handleRemoveSubject = (indexToRemove) => {

    const updatedSubjects = currentSubjects.filter((_, index) => index !== indexToRemove);
    setValue("subjects", updatedSubjects);

    setNewSubject({ name: "", marks: 100, isPractical: false }); // Reset input

  };

  const handleSaveCourse = async (values) => {

    console.log({ values, newSubject });

    if (isEditing) {
      await updateCourse(values);
    } else {
      await addCourse(values);
    }
    handleCloseDialog();
  };

  const handleDeleteCourse = async () => {
    await deleteCourse(deleteCourseId);
    setDeleteCourseId(null)
  };

  if (isCoursesLoading) {
    return <TableSkeleton />
  }


  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Courses List
        </Typography>
        <Button
          variant="contained"
          sx={{ background: "#454751d1", fontSize: 15 }}
          startIcon={<AddIcon />}
          onClick={() => handleOpenDialog()}
        >
          Add Course
        </Button>
      </Box>

      {/* Courses Table */}
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow sx={{ "& th": { fontSize: "14px", fontWeight: "bold" } }}>
              <TableCell>Title</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Subjects</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>

            {courses?.map((course) => (
              <TableRow key={course._id} sx={{ "& td": { fontSize: "14px" } }}>
                <TableCell>{course.title}</TableCell>
                <TableCell>{course.duration}</TableCell>
                <TableCell>
                  {course?.subjects?.length > 0 ?
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {course.subjects.map((subject) => (
                        <Chip
                          key={subject._id}
                          label={<Typography variant="h6">{subject.name} ({subject.marks})</Typography>}
                          size="medium"
                          color="primary"
                          variant="outlined"
                        />
                      ))}


                    </Box> : <>-</>}
                </TableCell>
                <TableCell align="right">
                  <IconButton
                    color="primary"
                    onClick={() => handleOpenDialog(course)}
                    size="small"
                  >
                    <EditIcon fontSize="large" />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => setDeleteCourseId(course._id)}
                    size="small"
                  >
                    <DeleteIcon fontSize="large" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {courses?.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography variant="h6"> No courses found. Add a course to get started.</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Course Dialog */}
      <Dialog open={open} onClose={handleCloseDialog} fullWidth maxWidth="sm">
        <form onSubmit={handleSubmit(handleSaveCourse)}>
          <DialogTitle>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              {isEditing ? "Edit Course" : "Add New Course"}
              <IconButton
                edge="end"
                color="inherit"
                onClick={handleCloseDialog}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ padding: 3 }}>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, md: 6 }}>
                <CustomTextField
                  {...register("title", { required: "Course Title is required" })}
                  fullWidth
                  label="Course Title*"
                  error={!!errors.title} // Shows error state if validation fails
                  helperText={errors.title?.message} // Display custom error message
                />
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <CustomTextField
                  {...register("code", { required: "Course Code is required" })}
                  fullWidth
                  label="Course Code*"
                  error={!!errors.title} // Shows error state if validation fails
                  helperText={errors.title?.message} // Display custom error message
                />
              </Grid>
              <Grid size={{ xs: 12, md: 12 }}>
                <CustomTextField
                  {...register("duration", { required: "Course Title is required" })}
                  fullWidth
                  label="Duration*"
                  name="duration"
                  error={!!errors.title} // Shows error state if validation fails
                  helperText={errors.title?.message} // Display custom error message
                  placeholder="e.g. 6 months"
                />
              </Grid>
            </Grid>

            {/* <Typography variant="h6" sx={{ mt: 3, mb: 2 }}>
            Subjects
          </Typography> */}

            <Grid container spacing={2} alignItems="center" mt={2}>
              <Grid size={{ xs: 12, sm: 3 }}>
                <CustomTextField
                  fullWidth
                  label="Subject Name"
                  name="name"
                  value={newSubject.name}
                  onChange={handleSubjectChange}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <CustomTextField
                  fullWidth
                  label="Max Marks"
                  name="marks"
                  type="number"
                  value={newSubject.marks}
                  onChange={handleSubjectChange}
                  InputProps={{
                    inputProps: { min: 0, max: 100 },
                  }}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={newSubject.isPractical || false}
                      onChange={handleSubjectChange}
                      name="isPractical"
                    />
                  }
                  label={<Typography variant="h6">Is Practical ?</Typography>}
                />
              </Grid>
              <Grid size={{ xs: 12, sm: 3 }}>
                <Button
                  variant="contained"
                  sx={{ p: 1, background: "#454751d1" }}
                  onClick={handleAddSubject}
                  disabled={newSubject?.name?.trim()?.length === 0}

                >
                  Add Subject
                </Button>
              </Grid>
            </Grid>


            <TableContainer component={Paper} variant="outlined" sx={{ mt: 2 }}>
              <Table>
                <TableHead>
                  <TableRow
                    sx={{ "& th": { fontSize: "14px", fontWeight: "bold" } }}
                  >
                    <TableCell>Subject Name</TableCell>
                    <TableCell>Max. Marks</TableCell>
                    <TableCell>Is Practical ?</TableCell>

                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentSubjects?.length > 0 ? <>{currentSubjects?.map((subject, index) => (
                    <TableRow
                      key={index}
                      sx={{ "& td": { fontSize: "14px" } }}
                    >
                      <TableCell>{subject?.name}</TableCell>
                      <TableCell>{subject?.marks}</TableCell>
                      <TableCell>{subject?.isPractical ? "Yes" : "No"}</TableCell>
                      <TableCell align="right">
                        <IconButton
                          color="error"
                          onClick={() => handleRemoveSubject(index)}
                          size="small"
                        >
                          <DeleteIcon fontSize="large" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}</> : <TableRow>
                    <TableCell
                      colSpan={4}
                      align="center"
                      sx={{ fontSize: "14px" }}
                    >
                      No subjects found.
                    </TableCell>
                  </TableRow>}
                </TableBody>
              </Table>
            </TableContainer>

          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseDialog}
              sx={{ fontSize: 14, color: "#454751d1" }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              sx={{ fontSize: 14, background: "#454751d1" }}
              variant="contained"
              disabled={isAddingCourse || isUpdatingCourse}
            >
              Save
            </Button>
          </DialogActions>
        </form>
      </Dialog>


      {/* Delete Course Dialog */}
      <Dialog open={!!deleteCourseId} onClose={() => setDeleteCourseId(null)} fullWidth maxWidth="sm">
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Delete Course
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setDeleteCourseId(null)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ padding: 3 }}>
          Are you sure you want to delete this course?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteCourseId(null)}
            sx={{ fontSize: 13, color: "#454751d1" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteCourse}
            sx={{ fontSize: 13 }}
            variant="contained"
            disabled={isDeletingCourse}
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CourseManagement;
